import * as R from 'ramda'

export const isNilOrEmpty = R.either(R.isNil, R.isEmpty)
export const isNotNilOrEmpty = R.compose(R.not, isNilOrEmpty)
export const defaultIfEmpty = (defaultValue, value) => R.isEmpty(value) ? defaultValue : value
export const defaultIfNilOrEmpty = (defaultValue, value) => isNilOrEmpty(value) ? defaultValue : value

export const withFixedArg = (fn, ...args) => () => fn(...args)
